import Client from './baseUserClient';
const http = new Client(process.env.REACT_APP_BACKEND_URL);

export const verifyPhone = (data) => {
  let phone = data.replace('+', '%2B');
  let url = `api/user/phoneRegistered?phoneNumber=${phone}`;
  return http.get(url);
};

export const signInWithIdToken = (data) => {
  return http.post(`api/user/signin`, data);
};

export const verifyPublicUserAccessToken = (data, navigation) => {
  return http.post('api/user/verifyToken', data, navigation);
};

export const getVerificationBucket = (params) => {
  let url = `api/verification-bucket?`;
  Object.keys(params).forEach((key) => {
    const value = params[key];
    url += `${key}=${value}&`;
  });
  return http.get(url);
};

export const buyBucket = (id) => {
  return http.post(`api/verification-bucket/buy/${id}`);
};

export const cancelInvoice = (id) => {
  return http.delete(`api/verification-bucket/${id}`);
};

export const getPublicUserInvoices = (params = { page: 1, perPage: 100 }) => {
  let url = `api/verification-bucket/user-invoices?`;
  Object.keys(params).forEach((key) => {
    const value = params[key];
    url += `${key}=${value}&`;
  });
  return http.get(url);
};

// verify certificate api
export const verifyCertificate = (data) => {
  return http.post(`api/certificates/verify`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// verify certificate api
export const verifyHistoryContract = (data) => {
  return http.post(`api/user/verify-contract-certificate`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
